import CommiteeDecisionForm from './CommitteeDecisionForm';

const ComitteeRewriteDecision = ({ offerID, step, status }) => {
  return (
    <CommiteeDecisionForm
      offerID={offerID}
      step={step}
      status={status}
    />
  );
};

export default ComitteeRewriteDecision;
